var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 510 510",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M474.4,253.9c18,0,32.6-14.6,32.6-32.6c0-18-14.6-32.6-32.6-32.6s-32.6,14.6-32.6,32.6 C441.8,239.2,456.4,253.9,474.4,253.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2,221.3c0-18-14.6-32.6-32.6-32.6S3,203.3,3,221.3c0,18,14.6,32.6,32.6,32.6S68.2,239.2,68.2,221.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.6,110.7c0-18-14.6-32.6-32.6-32.6s-32.6,14.6-32.6,32.6c0,18,14.6,32.6,32.6,32.6S287.6,128.6,287.6,110.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8,263.1l83.8,168.9h228.7l83.8-168.9c-2.4-1.2-4.8-2.7-6.9-4.3l-103.5,52.5c-3.5,1.8-7.8,0.4-9.6-3.1L255,158.7 l-78.2,149.5c-1.8,3.5-6.1,4.8-9.6,3.1L63.8,258.7C61.6,260.4,59.3,261.8,56.8,263.1L56.8,263.1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c23d4c1f3a04687087a6bf453d9748c3.svg";
export { ForwardRef as ReactComponent };